import { Box, Stack, type StackProps, Typography } from "@mui/material";

type BaseHeaderWrapperProps = {
  title: string;
  startIcon?: React.ReactNode;
  subTitle?: string;
  small?: boolean;
} & StackProps;

export const BaseHeaderWrapper = ({
  title,
  subTitle,
  children,
  ...props
}: BaseHeaderWrapperProps) => {
  return (
    <Stack spacing={3} {...props}>
      <Stack spacing={1}>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          {props.startIcon}
          <Typography
            variant={props.small ? "body1" : "h2"}
            fontSize="18px"
            fontWeight={700}
          >
            {title}
          </Typography>
        </Stack>
        {subTitle && (
          <Typography variant="body2" color="grey.500">
            {subTitle}
          </Typography>
        )}
      </Stack>
      <Box>{children}</Box>
    </Stack>
  );
};
